var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { arrowIcon, link, longArrowIcon, underlining, buttonStyle } from './link.css';
import { cx } from '@emotion/css';
import { Typography } from '@axafr-btc-ds/typography';
import { IconArrowForward, IconArrowRight, IconSize } from '@axafr-btc-ds/icons';
import React from 'react';
// eslint-disable-next-line max-len, complexity
export var Link = function (_a) {
    var _b, _c;
    var className = _a.className, _d = _a.type, type = _d === void 0 ? 'underlined' : _d, _e = _a.isColoredBackground, isColoredBackground = _e === void 0 ? false : _e, children = _a.children, props = __rest(_a, ["className", "type", "isColoredBackground", "children"]);
    var target = props.target, href = props.href;
    // Security best practice
    var additionalLinkAttributes = target === '_blank' ? { rel: 'noopener' } : {};
    return (React.createElement(Typography, __assign({ variant: "link", component: href ? 'a' : 'button', type: !href ? 'button' : undefined }, props, additionalLinkAttributes, { className: cx(link(isColoredBackground), (_b = {}, _b[buttonStyle] = !href, _b), className, (_c = {}, _c[underlining(isColoredBackground)] = type === 'underlined', _c)) }),
        type === 'arrow' && React.createElement(IconArrowRight, { size: IconSize.xs, className: cx(arrowIcon, 'icon') }),
        children,
        type === 'longArrow' && React.createElement(IconArrowForward, { className: cx(longArrowIcon, 'icon') })));
};
